<template>
	<div id="lightbox">
		<div class="lightbox">
			<div class="lightbox__content">
				<div class="lightbox__wrapper">
					<div class="lightbox__wrapper--inner">
                        <slot></slot>
					</div>
				</div>
				<a href="#close" class="lightbox__close" @click.prevent="close()"><span>Zavrit</span></a>
			</div>
		</div>
		<div class="lightbox lightbox__bg"></div>
	</div>
</template>

<script>
export default {
	props: {
		'close': Function
	}
}
</script>

<style lang=less>
	@import "../../assets/less/default.less";

	#lightbox { .top-left(); width: 100%; height: 100%; max-height: 0; max-width: 0; display: block; overflow: hidden; overflow-y: auto; transition: max-width 0s ease .5s, max-height 0s ease .5s; }
	.lightbox { .size(100%, 100%); .top-left(); z-index: 120; display: flex;
		&__bg { .bgc(black); opacity: 0; .size(100%, 100%); .top-left(); position: sticky; z-index: 110; transition: opacity .5s ease-in .5s; }
		&__content { position: relative; .size(80vw, auto); margin: auto; .bgc(@creme); padding: 2rem; }
		&__wrapper { position: relative; .size(100%,100%); overflow: hidden;
			&:before, &:after { display: inline-block; .size(30px,30px); content: ""; .bgc(@creme); border: 2px solid @cremeLight; border-radius: 50%; }
			&:before { .top-left(-15px,-15px); }
			&:after { .top-right(-15px,-15px); }
			&--inner { .size(100%, 100%); border: 2px solid @cremeLight;
				&:before, &:after { display: inline-block; .size(30px,30px); content: ""; .bgc(@creme); border: 2px solid @cremeLight; border-radius: 50%; }
				&:before { .bottom-left(-15px,-15px); }
				&:after { .bottom-right(-15px,-15px); }
			}
		}
		&__close { .top-right(.5rem,.5rem); .size(2rem,2rem); transform: rotate(45deg);
			span { display: none; }
			&:before { .top-left(50%,0); margin-top: -1px; display: inline-block; content: ""; .size(100%, 2px); .bgc(@grey); }
			&:after { .top-left(0,50%); margin-left: -1px; display: inline-block; content: ""; .size(2px, 100%); .bgc(@grey); }

			&:hover:before { transform: rotate(90deg); transition: all .5s; }
			&:hover:after { transform: rotate(-90deg); transition: all .5s; }
		}
	}

	html.lightbox--active {
		#lightbox { transition: max-width 0s ease, max-height 0s ease;  }
		.lightbox {
			&__bg { opacity: .75; transition: opacity .5s ease-in; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/lightbox/LightboxBase.vue